import React from 'react'
import { ChevronDown, Save } from 'lucide-react'
import { ModernButton } from './ModernButton'

interface FormNavigationProps {
 currentStep: number
 totalSteps: number
 isSubmitting?: boolean
 isDisabled?: boolean
 onPrevious: () => void
 onNext: () => void
 onSubmit?: () => void
 submitLabel?: string
 nextLabel?: string
 previousLabel?: string
}

export const FormNavigation: React.FC<FormNavigationProps> = ({
 currentStep,
 totalSteps,
 isSubmitting = false,
 isDisabled = false,
 onPrevious,
 onNext,
 onSubmit,
 submitLabel = 'Salvar',
 nextLabel = 'Próxima',
 previousLabel = 'Anterior'
}) => {
 const isLastStep = currentStep === totalSteps

 return (
 <div className="flex items-center justify-between pt-6 border-t border-border">
<ModernButton
  type="button"
  variant="outline"
  onClick={onPrevious}
  disabled={currentStep === 1}
  className="flex items-center"
  >
  <ChevronDown className="h-4 w-4 mr-2 rotate-90" />
  {previousLabel}
  </ModernButton>

 <div className="text-sm text-muted-foreground">
 Etapa {currentStep} de {totalSteps}
 </div>

{!isLastStep ? (
  <ModernButton
    type="button"
    onClick={onNext}
    className="flex items-center"
    >
    {nextLabel}
    <ChevronDown className="h-4 w-4 ml-2 -rotate-90" />
  </ModernButton>
) : (
  <ModernButton
    type="button"
    onClick={onSubmit}
    loading={isSubmitting}
    className="flex items-center"
    disabled={isDisabled}
    >
    {isSubmitting ? (
      <>
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
        Salvando...
      </>
    ) : (
      <>
        <Save className="h-4 w-4 mr-2" />
        {submitLabel}
      </>
    )}
  </ModernButton>
)}
 </div>
 )
}

